import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Pagination, PaginationItem } from '@material-ui/lab';
import { Link } from 'react-router-dom';

import { getProjects, getProjectsBySearch } from '../../actions/projects';
import useStyles from './styles';
// import useCommonStyles from '../CommonStyle/commonStyle';
import { store } from '../../index';

type RootState = ReturnType<typeof store.getState>;

const ProjectPagination = ({ page, search, tags }: { page: number, search: string, tags: string[] }) => {
  const { numberOfPages } = useSelector((state: RootState) => state.projects);
  console.log("numberOfPages");
  console.log(numberOfPages);
  const dispatch = useDispatch();

  const classes = useStyles();
  // const commonClasses = useCommonStyles();

  useEffect(() => {
    if (page) {
      if (search === "" && tags.length === 0) {
        dispatch(getProjects(page));
      } else {
        dispatch(getProjectsBySearch({ search, tags: tags.join(',') }, page));
      }
    }
  }, [dispatch, page]);

  return (
    <Pagination
      classes={{ ul: classes.ul }}
      count={numberOfPages}
      page={page || 1}
      variant="outlined"
      shape="rounded"
      color="primary"
      renderItem={(item) => {
        if (search === "" && tags.length === 0) {
          return (<PaginationItem {...item} component={Link} to={`/projects?page=${item.page}`} />)
        } else {
          return (<PaginationItem {...item} component={Link} to={`/projects/?searchQuery=${search || ''}&tags=${tags.join(',')}&page=${item.page}`} />)
        }
      }}
    />
  );
};

export default ProjectPagination;